import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { DataProvider } from "./GlobalState";
import GlobalStyles from "./design/index";
import Pages from "./components/Pages";
import "./index.css";
import "./vaaripa_print.css"; // Global print styles
import "chartjs-adapter-moment";
import { ToastManager } from "./components/utils/Toast";
import { usePushToast } from "./hooks/usePushToast";

function AppContent() {
  const [legacyMessage, setLegacyMessage] = useState(null);

  // Start listening for foreground FCM messages → dispatches "push-toast" events
  usePushToast();

  useEffect(() => {
    // ── Auto-logout toast ──────────────────────────────────────────────────
    if (sessionStorage.getItem("autoLoggedOut") === "true") {
      setLegacyMessage("You have been automatically logged out.");
      sessionStorage.removeItem("autoLoggedOut");
    }

    // ── PWA update-available toast ─────────────────────────────────────────
    // Fired by index.js when the service worker has a new version ready.
    const onPwaUpdate = () => {
      window.dispatchEvent(
        new CustomEvent("push-toast", {
          detail: {
            title: "Update Available",
            body: "A new version of the app is ready. Refresh to update.",
            icon: null,
          },
        })
      );
    };
    window.addEventListener("pwa-update-available", onPwaUpdate);
    return () => window.removeEventListener("pwa-update-available", onPwaUpdate);
  }, []);

  return (
    <>
      <GlobalStyles />
      {/* Print-only Vaaripa logo header — hidden on screen, shown on every PDF print */}
      <div id="vaaripa-print-logo" style={{display:"none"}}>
        <img src="/Vaaripa_logo.png" alt="Vaaripa" />
      </div>
      {/* Single ToastManager handles push toasts, legacy alerts, and PWA update notices */}
      <ToastManager
        message={legacyMessage}
        onClose={() => setLegacyMessage(null)}
      />
      <Pages />
    </>
  );
}

function App() {
  return (
    <DataProvider>
      <Router>
        <AppContent />
      </Router>
    </DataProvider>
  );
}

export default App;
